import { render, staticRenderFns } from "./AddModelo.vue?vue&type=template&id=5f76e334"
import script from "./AddModelo.vue?vue&type=script&lang=js"
export * from "./AddModelo.vue?vue&type=script&lang=js"
import style0 from "./AddModelo.vue?vue&type=style&index=0&id=5f76e334&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports